export const EXTRA_DATA_TYPES = [
  { key: 'information', text: 'Information', value: 'information' },
  { key: 'warning', text: 'Warning', value: 'warning' },
  { key: 'instruction', text: 'Instruction', value: 'instruction' },
];
